import { Card, CardBody, Col } from 'reactstrap'
import { Prefixs } from '../../../../utils/Constant'
import PrefixForm from './PrefixForm'
import { defaultRangeData } from '../../../../Data/BonusUi/RangeSlider/RangeSlider'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const Prefix = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={Prefixs} span={defaultRangeData}/>
        <CardBody>
          <PrefixForm />
        </CardBody>
      </Card>
    </Col>
  )
}

export default Prefix